import styled from 'styled-components';

export const Box = styled.form`
    & > div {
        min-width: 256px;
    }
`;

export default Box;
